var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-form',{attrs:{"title":_vm.title,"submit-button-text":_vm.submitButtonText},on:{"submitUserForm":_vm.onSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }